document.addEventListener("DOMContentLoaded", () => {
	const featuredProductsSwipers = document.querySelectorAll(".featured-products__products-swiper");

	if (featuredProductsSwipers) {
		featuredProductsSwipers.forEach((swiperContainer) => {
			const swiper = new Swiper(swiperContainer, {
				// Optional parameters
				spaceBetween: 30,
				keyboard: true,
				slidesPerView: swiperContainer.dataset.slidesPerViewMobile,
				breakpoints: {
					768: {
						slidesPerView: swiperContainer.dataset.slidesPerViewMobileLg,
					},
					992: {
						slidesPerView: swiperContainer.dataset.slidesPerViewTablet,
					},
					1200: {
						slidesPerView: swiperContainer.dataset.slidesPerViewDesktop,
					}
				},

				pagination: {
					el: swiperContainer.parentElement.querySelector(".featured-products__swiper.swiper-pagination"),
					type: "fraction",
				},
				navigation: {
					nextEl: swiperContainer.parentElement.querySelector(".featured-products__swiper.swiper-button-next"),
					prevEl: swiperContainer.parentElement.querySelector(".featured-products__swiper.swiper-button-prev"),
				},
			});
		});
	}
});
